import React, { useState, useEffect, useContext } from "react";
import { Checkbox, Form, Input, InputNumber } from "antd";
import { AppContext } from "../../../context";
import { validateNIF } from "../lib/validateNIF";

const driverInfoFields = [
  "name",
  "address",
  "phone",
  "id_card",
  "driver_license",
  "nif",
];

function DriverInfo({ setDriverInfoFn, setDriverInfoFilled }) {
  // const [dInfo, setDInfo] = useState(null);
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const info = useContext(AppContext);
  const errorMessages = useState({});

  const validateField = (data, field) => {
    // name
    if (field === "name") return true;
    if (field === "address") return true;
    if (field === "phone") return true;
    if (field === "address") return true;
    if (field === "id_card") return true;
    if (field === "driver_license") return true;
    if (field === "nif" /*validateNIF(data[field])*/) return true;
    return false;
  };

  // useEffect(() => {
  //   // validate all fields
  //   // let count = 0;
  //   // // count validated fields
  //   // driverInfoFields.forEach(
  //   //   (f) =>
  //   //     dInfo &&
  //   //     Object.keys(dInfo)?.includes(f) &&
  //   //     validateField(dInfo, f) &&
  //   //     count++
  //   // );
  //   // if (count === driverInfoFields.length) setDriverInfoFilled(true);
  //   // else setDriverInfoFilled(false);

  //   // validate only name
  //   if (validateField(dInfo, "name") && privacy && terms)
  //     setDriverInfoFilled(true);
  //   else setDriverInfoFilled(false);
  // }, [dInfo, terms, privacy]);

  const onFormChange = (e, field) => {
    setDriverInfoFn({
      [field]: e.target.value || e.target.checked,
    });
    // setDInfo({ ...dInfo, [field]: e.target.value });
    // validate info
    // let count = 0;
  };

  return (
    <div>
      <div style={{ marginTop: 16, marginBottom: 10 }}>
        {info.t("driverInfo")}
      </div>
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 10,
        }}
        layout="horizontal"
        size="middle"
        onClick={() => console.log("CLICK")}
      >
        <Form.Item
          label={info.t("driverName")}
          rules={[{ required: true, message: "Please input your name!" }]}
          extra={errorMessages.name}
        >
          <Input onChange={(e) => onFormChange(e, "name")} maxLength={50} />
        </Form.Item>
        <Form.Item label={info.t("address")}>
          <Input onChange={(e) => onFormChange(e, "address")} />
        </Form.Item>
        <Form.Item label={info.t("phone")}>
          <Input onChange={(e) => onFormChange(e, "phone")} />
        </Form.Item>
        <Form.Item label={info.t("idCard")}>
          <Input onChange={(e) => onFormChange(e, "id_card")} />
        </Form.Item>
        <Form.Item label={info.t("driversLicense")}>
          <Input onChange={(e) => onFormChange(e, "driver_license")} />
        </Form.Item>
        <Form.Item label={info.t("nif")}>
          <Input onChange={(e) => onFormChange(e, "nif")} />
        </Form.Item>
      </Form>
      <Form.Item label={info.t("privacy")}>
        {/* <Checkbox onChange={(e) => setPrivacy(e.target.checked)}> */}
        <Checkbox onChange={(e) => onFormChange(e, "privacy")}>
          {info.t("understoodPrivacy")}
          <a
            href="https://aldeiashistoricasdeportugal.com/politica-de-privacidade-2/"
            target="_blank"
            rel="noreferrer"
          >
            {info.t("privacyPolitics")}
          </a>
        </Checkbox>
      </Form.Item>
      <Form.Item label={info.t("terms")}>
        {/* <Checkbox onChange={(e) => setTerms(e.target.checked)}> */}
        <Checkbox onChange={(e) => onFormChange(e, "terms")}>
          {info.t("readAndAcceptTerms")}
          <a
            href="https://aldeiashistoricasdeportugal.com/regulamentos-termos-utilizacao-da-mobilidade-urbana-sustentavel/"
            target="_blank"
            rel="noreferrer"
          >
            {info.t("mobilityTerms")}
          </a>
        </Checkbox>
      </Form.Item>
    </div>
  );
}

export default DriverInfo;
